import { useQuery } from '@tanstack/react-query';

import { openApiFetch } from '@/lib/openapi-fetch';

import { settingsKeys } from './keys';

const CLIENT_GSL_INCLUDE = ['industries', 'locations', 'technologies_used'] as const;

export const parseClientId = (value: unknown): number | undefined => {
  const clientId = Number(value);
  return Number.isFinite(clientId) && clientId > 0 ? clientId : undefined;
};

export const useGetClient = (clientId: number | undefined) =>
  useQuery({
    queryKey: settingsKeys.client(clientId ?? 0),
    enabled: clientId != null,
    queryFn: () => {
      if (clientId == null) {
        throw new Error('Client id is required');
      }

      return openApiFetch('/clients/{resource_id}', {
        params: {
          path: { resource_id: clientId },
          query: { include: [...CLIENT_GSL_INCLUDE] },
        },
      });
    },
  });
